import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { WebchatLogCategory, WebchatLog, WebchatMessage } from '@feedyou/utils'

import { getAllVisibleLogCategories } from '../../../../features/try/utils'

export type VisibleLogCategory = Exclude<WebchatLogCategory, 'error'> | 'all'
export type TrySliceState = {
  isRunning: boolean
  introDialogId?: string
  visibleLogCategories: VisibleLogCategory[]
  webchatLog: {
    messages: WebchatMessage[]
    eventLogs: WebchatLog[]
  }
}

export const initialState: TrySliceState = {
  isRunning: false,
  introDialogId: undefined,
  visibleLogCategories: [],
  webchatLog: {
    messages: [],
    eventLogs: []
  }
}

export const slice = createSlice({
  name: 'try',
  initialState,
  reducers: {
    setIsRunning: (state, action: PayloadAction<boolean>) => {
      state.isRunning = action.payload
    },
    setIntroDialogId: (state, action: PayloadAction<string | undefined>) => {
      state.introDialogId = action.payload
    },
    addMessage: (state, action: PayloadAction<WebchatMessage>) => {
      state.webchatLog.messages.push(action.payload)
    },
    addEventLog: (state, action: PayloadAction<WebchatLog>) => {
      state.webchatLog.eventLogs.push(action.payload)
    },
    addVisibleLogCategory: (state, action: PayloadAction<VisibleLogCategory>) => {
      if (!state.visibleLogCategories.includes(action.payload)) {
        state.visibleLogCategories.push(action.payload)
      }
    },
    removeVisibleLogCategory: (state, action: PayloadAction<VisibleLogCategory>) => {
      state.visibleLogCategories = state.visibleLogCategories.filter(
        visibleLogCategory => visibleLogCategory !== action.payload
      )
    },
    addAllVisibleLogCategories: state => {
      state.visibleLogCategories = getAllVisibleLogCategories()
    },
    removeAllVisibleLogCategories: state => {
      state.visibleLogCategories = []
    },
    clearWebchatLogsAndMessages: state => {
      state.webchatLog = { messages: [], eventLogs: [] }
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
